import React from "react";
import CollapsibleSection from "./CollapsibleSection";

interface OrdererInfoSectionProps {
  userInfo: {
    username?: string;
    name?: string;
    phone_num?: string;
  } | null;
}

/**
 * 주문자 정보 섹션 (이름 + 전화번호)
 */
export default function OrdererInfoSection({ userInfo }: OrdererInfoSectionProps) {
  const displayName = userInfo?.username || userInfo?.name;
  const phone = userInfo?.phone_num
    ? userInfo.phone_num.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3")
    : "";

  return (
    <CollapsibleSection title="주문자 정보" fixed>
      <div className="rounded-2xl border border-gray-900 px-4 py-4">
        {!displayName ? (
          <p className="m-0 text-sm text-gray-400">로그인 후 구매가능합니다.</p>
        ) : (
          <div className="space-y-2 text-sm">
            <div className="flex items-center justify-between gap-4">
              <span className="text-gray-700">이름</span>
              <span className="font-semibold text-gray-900">{displayName}</span>
            </div>
            {phone && (
              <div className="flex items-center justify-between gap-4">
                <span className="text-gray-700">연락처</span>
                <span className="font-gmarket font-semibold text-gray-900">{phone}</span>
              </div>
            )}
          </div>
        )}
      </div>
    </CollapsibleSection>
  );
}
